@if ((layoutAnimationService.isEnterAppAnimationCompleted$ | async) === false) {
  <div class="my-layout my-layout-external"
    [@layoutAnimationEnterAppAnimation]="animationLogin"
    (@layoutAnimationEnterAppAnimation.done)="onEnterAppAnimationComplete($event)"
    >
    <div class="my-layout-content">
      <router-outlet></router-outlet>
    </div>
  </div>
}
